import { useThemeStore } from "~/stores/theme";

export default defineNuxtPlugin({
    name: "theme-plugin",
    setup() {
        const themeStore = useThemeStore();

        // Initialize theme on client-side only
        themeStore.initTheme();
    },
});
